var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('v-dialog',{attrs:{"value":_vm.value,"scrollable":"","max-width":"500"},on:{"click:outside":_vm.close}},[_c('BookingAvailability',_vm._g({attrs:{"item":_vm.item,"channel":_vm.channel,"location":_vm.location,"disable-slot-selection":!_vm.customer},on:{"close":_vm.close}},_vm.$listeners))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }